import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ScrollToTop from './components/ScrollToTop'
import SiteShell from './components/layout/SiteShell'
import HomePage from './pages/HomePage'
import ExplorePage from './pages/ExplorePage'
import ArchivesPage from './pages/ArchivesPage'
import ArchiveGatewayPage from './pages/ArchiveGatewayPage'
import PodcastsPage from './pages/PodcastsPage'
import PodcastDetailPage from './pages/PodcastDetailPage'
import DocumentariesPage from './pages/DocumentariesPage'
import CuratorsPage from './pages/CuratorsPage'
import VideoDetailPage from './pages/VideoDetailPage'
import ArtifactsPage from './pages/ArtifactsPage'
import ArtifactDetailPage from './pages/ArtifactDetailPage'
import ThemesPage from './pages/ThemesPage'
import ThemeDetailPage from './pages/ThemeDetailPage'
import SupportPage from './pages/SupportPage'
import AboutPage from './pages/AboutPage'
import LoginPage from './pages/LoginPage'
import ProfilePage from './pages/ProfilePage'
import AuthVerifyPage from './pages/AuthVerifyPage'
import NotFoundPage from './pages/NotFoundPage'
import SearchPage from './pages/SearchPage'
import ContactPage from './pages/ContactPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'

export default function App() {
  return (
    <AuthProvider>
      <ScrollToTop />
      <SiteShell>
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/explore" element={<ExplorePage />} />
            <Route path="/archives" element={<ArchivesPage />} />
            <Route path="/archive/:archiveKey" element={<ArchiveGatewayPage />} />
            <Route path="/podcasts" element={<PodcastsPage />} />
            <Route path="/podcast/:id" element={<PodcastDetailPage />} />
            <Route path="/conversations" element={<DocumentariesPage />} />
            <Route path="/curators" element={<CuratorsPage />} />
            <Route path="/video/:id" element={<VideoDetailPage />} />
            <Route path="/artifacts" element={<ArtifactsPage />} />
            <Route path="/artifact/:slug" element={<ArtifactDetailPage />} />
            <Route path="/themes" element={<ThemesPage />} />
            <Route path="/themes/:slug" element={<ThemeDetailPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/auth/verify" element={<AuthVerifyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </SiteShell>
    </AuthProvider>
  )
}
